import React from "react";
import {useDrag} from "react-dnd";
import {IItem} from "../../interfaces/Item";
import {Icon, MenuItem, SemanticICONS} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {AddItemToLabel, SelectItem} from "../MainActions";
import {BARCODE, HORIZONTAL_LINE, VERTICAL_LINE} from "../../utils/ItemTypes";
import {GenerateBarcode} from "../BarcodeActions";
import {defaultBarcode} from "../../utils/defaultBarcode";
import {getBarcodeDefaultValue} from "../../utils/barcodeUtils";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import { useTranslation } from "react-i18next";
type DragProps = {
  item: IItem;
  setZoom: (i: number) => void;
};

export const DraggableItem = ({item, setZoom}: DragProps) => {
  const dispatch = useAppDispatch();
  const {labelItems, labelParams} = useSelector((state: RootState) => state.labelEdit.present);
  const {barcodeTags} = useSelector((state: RootState) => state.refData);
  const {t} = useTranslation();
  const [{isDragging}, drag] = useDrag(() => ({
    type: item.type,
    item: item,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const handleItemClick = async () => {
    setZoom(0);
    item.itemid = Math.floor(Number((labelItems.length + 1).toString() + (Math.random() * 100000000).toString()));
    item.width = 20;
    item.fontSize = 12;
    item.style = {
      position: "absolute",
      top: "0px",
      left: "0px",
    };
    item.xInMM = 0;
    item.yInMM = 0;
    if (item.type === BARCODE) {
      const barcodeUrl = await dispatch(GenerateBarcode(item.itemid));
      if (barcodeUrl) {
        item.value = barcodeUrl;
      }
      item.width = defaultBarcode.Width;
      item.height = defaultBarcode.Height;
      item.name = defaultBarcode.Name;
      item.showCaption = Boolean(defaultBarcode.ShowCaption);
      item.captionSize = defaultBarcode.CaptionSize;
      item.barcodeType = defaultBarcode.Type;
      item.defaultText = getBarcodeDefaultValue(barcodeTags, defaultBarcode.Name);
    }

    if (item.type === HORIZONTAL_LINE || item.type === VERTICAL_LINE) {
      const offset = 10;
      const labelWidth = labelParams.widthInPx * labelParams.pxInMM;
      const labelHeight = labelParams.heightInPx * labelParams.pxInMM;
    
      item.xInMM = Math.min(offset, labelWidth / 2);
      item.yInMM = Math.min(offset, labelHeight / 2);
      item.style = {
        position: "absolute",
        top: item.xInMM * labelParams.pxInMM + "px",
        left: item.yInMM * labelParams.pxInMM + "px",
      };
    }

    dispatch(AddItemToLabel(item)).then(() => {
      dispatch(SelectItem(item));
      setZoom(1);
    });
  };

  return (
    <div ref={drag} style={{opacity: isDragging ? 0.5 : 1, cursor: "move"}} onClick={handleItemClick}>
      <MenuItem as="a" id={item.id} className="item-select">
        <Icon name={item.iconName as SemanticICONS} />
        {t(item.text)}
      </MenuItem>
    </div>
  );
};
